import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice";
import usersReducer from "../slices/usersSlice";
import productsReducer from "../slices/productsSlice";
import batchesReducer from "../slices/batchesSlice";
import dashboardReducer from "../slices/dashboardSlice";
import prodsealsReducer from "../slices/prodsealsSlice";
import scanHistoryReducer from "../slices/scanHistorySlice";
import organizationReducer from "../slices/organizationSlice";
import customerReducer from "../slices/customerSlice";
import brandsReducer from "../slices/brandsSlice";
import impersonationReducer from "../slices/impersonationSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  products: productsReducer,
  batches: batchesReducer,
  dashboard: dashboardReducer,
  prodseals: prodsealsReducer,
  scanHistory: scanHistoryReducer,
  organization: organizationReducer,
  customers: customerReducer,
  brands: brandsReducer,
  impersonation: impersonationReducer,
});

export default rootReducer;
